var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"secondary"},[_c('v-container',{staticStyle:{"height":"100vh"},attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('confirmation-message')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }